import RepositoryWorker from "../RepositoryWorker";
import {Store} from "vuex";
import {AxiosRequestConfig} from 'axios';

export enum SensorValueType {
    RAW = 'number',
    DICTIONARY = 'dictionary',
}

export interface SensorInfoConfig {
    type: SensorValueType;
    name: string;
    path: string;
    dictionary?: {name: string, value: any}[];
}

export interface SensorInfo {
    type: string;
    nameKey: string;
    config: { values: SensorInfoConfig[] };
}

export class SensorsRepository {
    static getOneByDeviceId(store: Store<any>, deviceId: number, config?: AxiosRequestConfig): Promise<{sections: SensorInfo[]}> {
        try {
            config?.cancelToken?.throwIfRequested();
        } catch (error) {
            return Promise.reject(error);
        }
        const stored = store.state.deviceSensorConfig.find((q: {device: number, config: {sections: SensorInfo[]}}) => q.device === deviceId);
        if (stored) {
            return new Promise(
                (resolve) => {
                    resolve(stored.config);
                }
            );
        }
        const url = `/api/v1/monitoring/devices/${deviceId}/info_configuration`;
        const request = config
            ? RepositoryWorker.makeGetCallInternal<{sections: SensorInfo[]}>(url, undefined, config)
            : RepositoryWorker.makeGetCallInternal<{sections: SensorInfo[]}>(url);
        return request
            .then(response => {
                config?.cancelToken?.throwIfRequested();
                store.commit(
                    'saveDeviceSensorsConfig',
                    {
                        device: deviceId,
                        config: response,
                    }
                );
                return response;
            });
    }

}
